import { Button, Space, Text, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";

import { useCreateCommentMutation } from "../../api/comments.api";
import { MutableCommentDto } from "../../models/comments.models";
import { EventSource } from "../../models/event.models";

export interface CommentEntryProps {
	sourceId: string;
	sourceType: EventSource;
}

export const CommentEntry = ({ sourceId, sourceType }: CommentEntryProps) => {
	const createCommentMutation = useCreateCommentMutation();

	const form = useForm<MutableCommentDto>({
		initialValues: {
			Comment: '',
			SourceId: sourceId,
			SourceType: sourceType
		}
	});

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (form.values.Comment.trim() === '') return;

		createCommentMutation.mutate(form.values, {
			onSuccess: () => {
				form.reset();
			}
		});
	};

	return <>
		<Text fz="xs" fw="700" tt="uppercase" c="dimmed">Comments</Text>
		<Space h="sm" />
		<form onSubmit={handleSubmit} className="mt-4">
			<Textarea
				key={form.key("Comment")}
				{...form.getInputProps("Comment")}
				placeholder="Write a comment..."
				autosize={true}
				minRows={3}
				maxLength={500}
			/>
		
			<Space h="sm" />
			<Button type="submit" radius="md" loading={createCommentMutation.isPending} disabled={form.values.Comment.trim() === ''}>
				{createCommentMutation.isPending ? 'Submitting...' : 'Submit Comment'}
			</Button>
		</form>
	</>
}